import Carousel from "../SharedComponents/Carousel";
import ProductCard from "./SharedComponents/ProductCard";

const ProductsSection = ({ productData, title }) => {
  return (
    <section className="w-full">
      <div className="w-full bg-[#F5E9D7] py-[50px] border-solid border-2 border-[#D4A373]">

        {title && (
          <div className="text-3xl font-semibold pl-14 mb-6">
            {title}
          </div>
        )}

        <div className="hidden md:flex flex-wrap justify-center gap-20 px-8">
          {productData.map((product, index) => (
            <div key={index} className="flex justify-center items-center py-[20px]">
              <ProductCard
                title={product.name}
                image={product.image}
                content={product.content}
                price={product.price}
              />
            </div>
          ))}
        </div>

        <div className="mt-2 md:hidden xs:mt-0 flex justify-center">
          <Carousel autoSlide={true} isProduct={true}>
            {productData.map((product, index) => (
              <ProductCard
                key={index}
                title={product.name}
                image={product.image}
                content={product.content}
                price={product.price}
              />
            ))}
          </Carousel>
        </div>
      </div>
    </section>
    
  );
};

export default ProductsSection;
